import React from "react";
import ReactDOM from "react-dom";
import { Router, Route, browserHistory } from "react-router";
import * as Sentry from "@sentry/browser";
import util from "../components/util/util";

import "./jquery-deparam";

import FourOhFour from "../components/404/404";
import App from "../components/app/app";
import CampaignDetail from "../components/campaign-detail/campaign-detail";
import CampaignForm from "../components/campaign-form/campaign-form";
import CampaignList from "../components/campaign-list/campaign-list";
import ChangeLogByObj from "../components/change-log-by-obj/change-log-by-obj";
import ChangeLogByUser from "../components/change-log-by-user/change-log-by-user";
import ChangeLogList from "../components/change-log-list/change-log-list";
import ConflictForm from "../components/conflict-form/conflict-form";
import InviteForm from "../components/invite-form/invite-form";
import InviteList from "../components/invite-list/invite-list";
import Livestream from "../components/livestream/livestream";
import PodDetail from "../components/pod-detail/pod-detail";
import PodList from "../components/pod-list/pod-list";
import SpotDetail from "../components/spot-detail/spot-detail";
import SpotList from "../components/spot-list/spot-list";
import PodForm from "../components/pod-form/pod-form";
import SpotForm from "../components/spot-form/spot-form";
import Reports from "../components/reports/reports";
import RuleDetail from "../components/rule-detail/rule-detail";
import RuleForm from "../components/rule-form/rule-form";
import RuleList from "../components/rule-list/rule-list";
import ScheduleByDay from "../components/schedule-by-day/schedule-by-day";
import ScheduleByTimeslot from "../components/schedule-by-timeslot/schedule-by-timeslot";
import ScheduleByWeek from "../components/schedule-by-week/schedule-by-week";
import Settings from "../components/settings/settings";
import UserForm from "../components/user-form/user-form";
import UserList from "../components/user-list/user-list";

const jQuery = window.jQuery;

document.addEventListener(`DOMContentLoaded`, () => {
  const onUpdate = () => {
    // do this immediately on route change;
    window.scrollTo(0, 0);
    jQuery(`.popover`).remove();

    // run these on a slight delay so the UX isn't jaring;
    setTimeout(() => {
      jQuery(`#page-header__collapse--account`).collapse(`hide`);
      jQuery(`#page-header__collapse--nav`).collapse(`hide`);
    }, util.delayList);
  };
  // initialize sentry
  const sentryDsns = {
    "aim.console.pbs.org":
      "https://e0fe70ddef5e498ea05fa98664e11eac@o260369.ingest.sentry.io/5223056",
    "aim-staging.console.pbs.org":
      "https://5af4d0a5f0864d5fa6a1067f53e678ed@o260369.ingest.sentry.io/5223049",
    defaults: ""
  };
  const sentry_dsn = sentryDsns[window.location.host] || sentryDsns.defaults;
  if (sentry_dsn) {
    Sentry.init({
      dsn: sentry_dsn
    });
  }

  ReactDOM.render(
    <Router onUpdate={onUpdate} history={browserHistory}>
      <Route path="/" component={App}>
        <Route path="/changelog/" component={ChangeLogList} />
        <Route path="/changelog/:page/" component={ChangeLogList} />
        <Route path="/changelog/user/:id/" component={ChangeLogByUser} />
        <Route path="/changelog/user/:id/:page/" component={ChangeLogByUser} />
        <Route path="/changelog/:obj/:id/" component={ChangeLogByObj} />
        <Route path="/changelog/:obj/:id/:page/" component={ChangeLogByObj} />

        <Route path="/campaigns/" component={CampaignList} />
        <Route path="/campaigns/:page/" component={CampaignList} />
        <Route path="/campaign/:id/" component={CampaignDetail} />
        <Route path="/campaign/form/:id/" component={CampaignForm} />
        <Route path="/campaign/form/:id/pod/:podId/" component={CampaignForm} />

        <Route path="/conflicts/" component={ConflictForm} />
        <Route path="/conflicts/:count/" component={ConflictForm} />

        <Route path="/invites/" component={InviteList} />
        <Route path="/invites/:page/" component={InviteList} />
        <Route path="/invite/form/:id/" component={InviteForm} />

        <Route path="/livestream/" component={Livestream} />

        <Route path="/pods/" component={PodList} />
        <Route path="/pods/:page/" component={PodList} />
        <Route path="/pod/:id/" component={PodDetail} />
        <Route path="/pod/form/:id/" component={PodForm} />
        <Route path="/pod/form/:id/spot/:spotId" component={PodForm} />
        <Route path="/spots/" component={SpotList} />
        <Route path="/spots/:page/" component={SpotList} />
        <Route path="/spot/:id/" component={SpotDetail} />
        <Route path="/spot/form/:id/" component={SpotForm} />

        <Route path="/reports/" component={Reports} />
        <Route path="/reports/:page/" component={Reports} />

        <Route path="/rules/" component={RuleList} />
        <Route path="/rules/:page/" component={RuleList} />
        <Route path="/rule/:id/" component={RuleDetail} />
        <Route path="/rule/form/:id/" component={RuleForm} />
        <Route path="/rule/form/:id/pod/:podId/" component={RuleForm} />
        <Route
          path="/rule/form/:id/campaign/:campaignId/"
          component={RuleForm}
        />

        <Route path="/schedule/week/" component={ScheduleByWeek} />
        <Route path="/schedule/week/:day/" component={ScheduleByWeek} />

        <Route path="/schedule/day/" component={ScheduleByDay} />
        <Route path="/schedule/day/:day/" component={ScheduleByDay} />

        <Route path="/schedule/timeslot/" component={ScheduleByTimeslot} />
        <Route
          path="/schedule/timeslot/:timeslot/"
          component={ScheduleByTimeslot}
        />
        <Route
          path="/schedule/timeslot/:timeslot/:day/"
          component={ScheduleByTimeslot}
        />

        <Route path="/settings/" component={Settings} />

        <Route path="/users/" component={UserList} />
        <Route path="/users/:page/" component={UserList} />
        <Route path="/user/form/:id/" component={UserForm} />

        <Route path="*" component={FourOhFour} />
      </Route>
    </Router>,
    document.querySelector(`.container`)
  );
});
